<template>
  <PageHeader :title="customer.name"  v-if="customer" back save @back="toCustomer" @save="save" :valid='formValid' >

    <FormContainer>
      <v-row>

        <v-col cols="12" sm="4">
          <v-combobox ref="county" v-model="agent" :items="agents" :label="$t('agents')" :hint="$t('agents')" single-line></v-combobox >
        </v-col>

        <v-col cols="12" sm="4">
            <v-text-field
              v-model="quantity"
              :label="$t('quantity')"
              min=0
              max=10000
              type='number'
              :rules="numberRules"
            />
        </v-col>

        <v-col cols="12" sm="4">
          <DateInput 
            v-model="createdAt" 
            :label="$t('Date')"
            :max="new Date().toISOString().substr(0, 10)"
            :min="new Date(Date.now() - 60*24*60*60*1000).toISOString().substr(0, 10)"
            />
        </v-col>

      </v-row>
    </FormContainer>


  </PageHeader>
</template>


<script>
  import { v4 as uuidv4 } from 'uuid';
  import validationRules from '@/mixins/validationRules';
  import uzima from '@/mixins/uzimaUg';

  import PageHeader from '@/components/PageHeader';
  import FormContainer from '@/components/FormContainer';
  import DateInput from '@/components/DateInput'

  export default {

    components: { PageHeader, FormContainer, DateInput },

    data: () => ({
      quantity: 0,
      createdAt: (new Date().toISOString()).substr(0, 10),
      agent: undefined,
    }),

    computed: {
      uuid() { return this.$route.query.uuid; },
      customer() { return this.$store.getters.customer(this.uuid); },
      agents() { return this.$store.getters.uzima_ug_agents.map( e => { return { text: e.name, value: e.id }; }); },
      crop() { return this.$store.getters.crops[0]; },

      location() { return ((this.$store.getters.geolocation || {}).coords); },
      fieldAgentId() { return this.$store.getters.settings.fieldAgentId; },

      formValid() { return this.agent && Number(this.quantity)>0; },
    },

    methods: {
      save() {

        const geographics = this.$store.getters.settings.fieldAgentGeographics;

        let agentDetail = this.getAgent(this.agent);

        const delivery = {
          uuid: uuidv4(),
          createdAt: this.createdAt + (new Date().toISOString()).substr(10, 100),

          customerUuid: agentDetail.uuid,
          cropId: this.crop.value,
          quantity: parseInt(this.quantity),
          cropName: this.crop.text,

          country:  'TZ',
          region:   geographics[0],
          town:     geographics[1],

          unit:     'moc',

          deliveredToUuid: this.uuid,

          payload: { uzimaAgent: agentDetail },

          location: this.location,
          capturedById: this.fieldAgentId,
        }

        this.$store.dispatch('addDelivery', delivery);
        this.toCustomer();
      },
      toCustomer() { this.$router.push({ name: 'ShowCustomer', query: { uuid: this.uuid } }); },
      getAgent(agent) {
        let agentDetail = undefined;
        if (typeof(this.agent)==='string') {
          agentDetail = this.addAgent(agent);
        } else {
          agentDetail = this.$store.getters.uzima_ug_agents.filter( e => (e.id===this.agent.value) )[0];
        }
        return agentDetail;
      },

      addAgent(name) {
        let agent = { demographic: {} };
        agent.uuid = uuidv4();
        agent.isAFarmer = true;
        agent.name = name.trim();
        agent.fieldAgent = {
          id: this.$store.getters.settings.fieldAgentId,
          name: this.$store.getters.settings.name,
        };
        agent.demographic.regions = this.$store.getters.settings.fieldAgentGeographics;
        this.$store.dispatch('upsertCustomer', agent);
        return agent;
      },

    },

    mixins: [uzima, validationRules],

  }
</script>


<i18n>
{
  "en": {
    "agents": "Agent",
    "quantity": "Quantity Month Old Chicks"
  },
  "es": {
  },
  "sw": {
  }
}
</i18n>